var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("path",{"d":"M25.5,10.7a2.5,2.5,0,0,0-1.75-1.77C22.2,8.52,16,8.52,16,8.52s-6.2,0-7.75.41A2.5,2.5,0,0,0,6.5,10.7a26.34,26.34,0,0,0-.41,4.8,26.34,26.34,0,0,0,.41,4.8,2.5,2.5,0,0,0,1.75,1.77c1.55.41,7.75.41,7.75.41s6.2,0,7.75-.41A2.5,2.5,0,0,0,25.5,20.3a26.34,26.34,0,0,0,.41-4.8A26.34,26.34,0,0,0,25.5,10.7Z","fill":"#003c61","key":1}),React.createElement("polygon",{"points":"13.97 18.45 19.15 15.5 13.97 12.55 13.97 18.45","fill":"#fff","key":2})]);
}

YoutubeInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
